import { LoadError } from '@/components/LoadError';
import { useTranslation } from 'react-i18next';
import { useAuthEvents } from '@/lib/queries';

/**
 * История входов. Показывается и успешное, и неудачное: серия неудачных
 * попыток — первый признак, что адрес нашли (docs/SECURITY.md, раздел 12).
 */
export function LoginHistory() {
  const { t, i18n } = useTranslation();
  const events = useAuthEvents();

  if (events.isError) return <LoadError retry={() => events.refetch()} />;
  if (!events.data || events.data.length === 0) return null;

  return (
    <section className="flex flex-col gap-2" aria-label={t('auth.history')}>
      <h2 className="text-sm font-medium text-ink-2">{t('auth.history')}</h2>
      <ul className="flex flex-col gap-1">
        {events.data.map((event, index) => (
          <li
            key={`${event.createdAt}-${index}`}
            className="flex flex-wrap items-baseline justify-between gap-x-3 rounded-lg px-1 text-xs"
          >
            <span className={event.kind.includes('failed') ? 'text-near' : 'text-ink-2'}>
              {t(`auth.event.${event.kind}`)}
            </span>
            <span className="text-muted">
              {event.ipAddress ?? t('auth.unknownAddress')} ·{' '}
              {new Intl.DateTimeFormat(i18n.language, {
                dateStyle: 'short',
                timeStyle: 'short',
              }).format(new Date(event.createdAt))}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
